import { defineMessages } from 'react-intl';

export const scope = 'app.components.AdminPage';

export const messages = defineMessages({
  pageTitle: { id: `${scope}.pageTitle`, defaultMessage: 'Admin' },
  createAssociation: { id: `${scope}.createAssociation`, defaultMessage: 'Create a new association' },
  globalFormatTemplates: { id: `${scope}.globalFormatTemplates`, defaultMessage: 'Global Format Templates' },
  errCreateAssociation: {
    id: `${scope}.errCreateAssociation`,
    defaultMessage: "The association couldn't be created. Check the details and try again.",
  },
});
